module.exports = __webpack_public_path__ + "../resources/images/SkyCode_8-d7a4957cb2a45d8eaf266ea30bb101ad.svg";